
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vendor-faq",
      function () {
        return require("private-next-pages/vendor-faq.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vendor-faq"])
      });
    }
  